import { Box } from '@hivebrite/design-system/Box';
import { Flag } from '@hivebrite/design-system/Flag';
import { ScreenReadersContent } from '@hivebrite/design-system/ScreenReadersContent';

const RequestStatus = ({ requestIsPending }: { requestIsPending: boolean }) => (
  <Box position="absolute" ml={2} mt={2}>
    <Flag
      data-testid="private-group-label-wrapper"
      text={
        <>
          {s__(`Topics|${requestIsPending ? 'Pending request' : 'Private'}`)}
          <ScreenReadersContent>|</ScreenReadersContent>
        </>
      }
    />
  </Box>
);

export default RequestStatus;
